import { useEffect, useState } from "react";
import SubjectApi from "../../../services/subjectService";
import { useParams } from "react-router";
import InBoundForm from "../../../pages/appointment-details/InBoundForm";
import SkeletonLoader from "../../../utilites/SkeltonLoader";
import { notify } from "../../utils/methods/notification";

const InboundFormContainer = () => {
  const [subjectDetails, setSubjectDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams(); // Subject Id

  const getSubjectDetails = async () => {
    try {
      const res = await SubjectApi.getSubjectDetails(id);
      setSubjectDetails(res?.data);
    } catch (error) {
      notify.error(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    getSubjectDetails();
  }, []);

  
  return (
    <div className="p-4">
      {loading ? (
        <SkeletonLoader rowCount={1} height={80} isTable={false} />
      ) : (
        <InBoundForm
          getSubjectDetails={getSubjectDetails}
          patientData={subjectDetails}
          // inbond_form_id={}
          isFirstPartSubmitted={Boolean(subjectDetails?.inbond_patient?.id)}
          disabledAllFields={subjectDetails?.inbond_patient?.id ? true : false}
          printPatientInfo={subjectDetails}
        />
      )}
    </div>
  );
};

export default InboundFormContainer;
